import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonSvg } from '../Svg';
import { chameleonLinkThumbnail } from './LinkThumbnail.definition';
import { chameleonTooltipV3 } from '../TooltipV3/TooltipV3.definition';
import { chameleonTypography } from '../Typography/Typography.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTypography({ prefix }), chameleonLinkThumbnail({ prefix }), chameleonSvg({ prefix }), chameleonTooltipV3({ prefix }));
}
